// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

/** Pause (media). */
const icon: IconData = {
  id: "pause",
  name: "Pause",
  category: "media",
  styles: {
    rounded: {
      svg: '<path d="M16 19Q15.18 19 14.59 18.41T14 17V7Q14 6.18 14.59 5.59T16 5 17.41 5.59 18 7V17Q18 17.82 17.41 18.41T16 19M8 19Q7.18 19 6.59 18.41T6 17V7Q6 6.18 6.59 5.59T8 5 9.41 5.59 10 7V17Q10 17.82 9.41 18.41T8 19"/>',
    },
    sharp: { svg: '<path d="M14 19V5H18V19ZM6 19V5H10V19Z"/>' },
    outline: {
      svg: '<path d="M15 19Q14.18 19 13.59 18.41T13 17V7Q13 6.18 13.59 5.59T15 5H17Q17.82 5 18.41 5.59T19 7V17Q19 17.82 18.41 18.41T17 19ZM7 19Q6.18 19 5.59 18.41T5 17V7Q5 6.18 5.59 5.59T7 5H9Q9.82 5 10.41 5.59T11 7V17Q11 17.82 10.41 18.41T9 19ZM15 17H17V7H15ZM7 17H9V7H7ZM7 7V17ZM15 7V17Z"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M9.76 5.15L10.41 5.59 10.85 6.24 11 7V17L10.85 17.76 10.41 18.41 9.76 18.85 9 19H7L6.24 18.85 5.59 18.41 5.15 17.76 5 17V7L5.15 6.24 5.59 5.59 6.24 5.15 7 5H9ZM17.76 5.15L18.41 5.59 18.85 6.24 19 7V17L18.85 17.76 18.41 18.41 17.76 18.85 17 19H15L14.24 18.85 13.59 18.41 13.15 17.76 13 17V7L13.15 6.24 13.59 5.59 14.24 5.15 15 5H17Z"/></g><path d="M15 19Q14.18 19 13.59 18.41T13 17V7Q13 6.18 13.59 5.59T15 5H17Q17.82 5 18.41 5.59T19 7V17Q19 17.82 18.41 18.41T17 19ZM7 19Q6.18 19 5.59 18.41T5 17V7Q5 6.18 5.59 5.59T7 5H9Q9.82 5 10.41 5.59T11 7V17Q11 17.82 10.41 18.41T9 19ZM15 17H17V7H15ZM7 17H9V7H7ZM7 7V17ZM15 7V17Z"/>',
    },
  },
  animation: () => import("../animations/pause.js"),
};

export default icon;
